import classNames from "classnames";
import { useInView } from "react-intersection-observer";
import './index.scss'
const AnimatedBlock = ({ children }: { children: any }) => {
  const { ref, inView, entry } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  return (
    <div
      className={classNames("animated-block", inView && "animated")}
      ref={ref}
    >
      {children}
    </div>
  );
};

export default AnimatedBlock;
